import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Heart, Lock } from 'lucide-react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const LikeAlertBanner = () => {
  const navigate = useNavigate();
  const [count, setCount] = useState(0);

  useEffect(() => {
    axios
      .get(`${API}/likes/pending-count`, { withCredentials: true })
      .then((res) => setCount(res.data.count))
      .catch(() => {});
  }, []);

  if (count === 0) return null;

  return (
    <div
      className="mb-8 rounded-3xl p-8 shadow-lg bg-gradient-to-r from-pink-500 to-purple-500 text-white cursor-pointer hover:shadow-xl hover:-translate-y-1 transition-all"
      onClick={() => navigate('/upgrade')}
      data-testid="like-alert-banner"
    >
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-4">
          <div className="flex -space-x-3">
            {Array.from({ length: Math.min(count, 3) }, (_, i) => (
              <div
                key={i}
                className="w-12 h-12 rounded-full bg-white/25 backdrop-blur border-2 border-white flex items-center justify-center"
              >
                <Lock className="w-5 h-5 text-white" />
              </div>
            ))}
          </div>
          <div>
            <h3 className="text-lg font-bold flex items-center">
              <Heart className="w-5 h-5 mr-2 fill-white heart-beat" />
              {count === 1 ? 'Someone liked your voice!' : `${count} people liked your voice!`}
            </h3>
            <p className="text-sm text-white/85">Upgrade to see who and start chatting</p>
          </div>
        </div>
        <button
          className="px-5 py-2.5 rounded-full bg-white text-pink-600 font-semibold hover:bg-pink-50 transition-colors flex-shrink-0"
          data-testid="like-alert-upgrade-btn"
        >
          Reveal
        </button>
      </div>
    </div>
  );
};

export default LikeAlertBanner;
